import React, { useContext, useState, useEffect } from 'react'
import Slider from '../SliderHeader'
import "bootstrap/js/src/collapse.js";
import {Modal, Nav, Navbar, Button} from "react-bootstrap"
import MenuIcon from '@mui/icons-material/Menu';
import CancelIcon from '@mui/icons-material/Cancel';
import SliderOffer from '../SliderOffer';
import "./style.scss"
import CategoryIcon from '@mui/icons-material/Category';
import HomeIcon from '@mui/icons-material/Home';
import CartContext from '../../store/cart-context';
import { Link } from 'react-router-dom'
import ClearIcon from '@mui/icons-material/Clear';
import Cart from '../../components/Cart';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { auth, db } from "../../firebase"
import Geocode from "react-geocode";
import { useSelector, useDispatch } from 'react-redux'
import { updateLatitude, updateLongitude, updateAddress, updateAuthId } from '../../redux/dataSlice';
import Location from './Location';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import SignIn from './SignIn';
import SignUp from './SignUp';
import firebase from 'firebase'
import { useHistory } from "react-router-dom"
import { UpdateOutlined } from '@material-ui/icons';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import OnDelivery from '../../components/OnDelivery';
import OnPickUp from '../../components/OnPickUp';
import GooglePlacesAutocomplete, { geocodeByAddress, getLatLng, geocodeByLatLng } from 'react-google-places-autocomplete';
import Typewriter from 'typewriter-effect';
import SearchRestaurantLocation from "../SearchRestaurantsByLocation"
import HeaderCategories from '../MenuCategory/Header';
import Logo from "../../components/assets/logo.png"
import { toast } from 'react-toastify';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});




function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}


function Header() {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);
  const cartCtx = useContext(CartContext);
  const latitude = useSelector((state) => state.latitude);
  const longitude = useSelector((state) => state.longitude);
  const address = useSelector((state) => state.address);
  const dispatch = useDispatch();
  const [show1, setShow1] = useState(false);
  const history = useHistory()
  const [currentUser1, setCurrentUser1] = useState()
  const [post, setPost] = useState()
  const authId = useSelector((state) => state.authId);
  const [loggedUser, setLoggedUser] = useState("")
  const [homeAddress, setHomeAddress] = useState('')
  const [homeLat, setHomeLat] = useState('')
  const [homeLng, setHomeLng] = useState('')
  const [inputFieldHome, setInputFieldHome] = useState('')
  const [errorAddressHome, setErrorAddressHome] = useState('')
  const [inputFieldOffice, setInputFieldOffice] = useState('')
  const [address1, setAddress1] = useState('')
  const [loggedUid, setLoggedUid] = useState(null)
  const [show4, setShow4] = useState(false);

  const handleClose4 = () => setShow4(false);
  const handleShow4 = () => setShow4(true);

  const values = [true, 'sm-down', 'md-down', 'lg-down', 'xl-down', 'xxl-down'];
  const [fullscreen, setFullscreen] = useState(true);
  const [show3, setShow3] = useState(false);

  function handleShow3(breakpoint) {
    setFullscreen(breakpoint);
    setShow3(true);
  }
console.log("Address: ", latitude)
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if(user){
        const idTokenResult = await user.getIdTokenResult()
        dispatch({
          type: 'LOGGED_IN_USER',
          payload: {
            email: user.email,
            token: idTokenResult.token,
            
          }
        })
        setLoggedUid(`${user?.uid}`)
      }
    })
    return () => unsubscribe()
  }, [])


  const handleHomeLatLong = (e) =>{
    handleHomeLat(e)
    handleHomeLng(e)
    dispatch(updateAddress(e))
  }
  const handleHomeLat = (e)=>{
      setHomeAddress(e)
      geocodeByAddress(e)
      .then(results => getLatLng(results[0]))
      .then(latLng => 
          dispatch(updateLatitude(latLng.lat))
          
      )
      .catch(error => console.error('Error', error));        
  }
  const handleHomeLng = (e)=>{
      geocodeByAddress(e)
      .then(results => getLatLng(results[0]))
      .then(latLng => 
          dispatch(updateLongitude(latLng.lng))        
      )
      .catch(error => console.error('Error', error));        
  }

  const [open, setOpen] = React.useState(false);


  if(address === ''){
    navigator.geolocation.getCurrentPosition(function(position) {

      var lat1 = position.coords.latitude
      var long1 = position.coords.longitude
      setLat(lat1)
      setLong(long1)
     dispatch(updateLatitude(lat1))
     dispatch(updateLongitude(long1))
     getAddress(lat1,long1)
    });
  }
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose2 = () => {
    setOpen(false);
  };

  useEffect(() => {
    db.collection('users').doc(`${loggedUid}`).onSnapshot((doc) => {
      setCurrentUser1(doc.data());
    });
}, [])
let {user} = useSelector((state)=> ({...state}));



  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const theme = useTheme();
  const [value, setValue] = React.useState(0);


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };


  const logout = () => {
    auth.signOut();
    // dispatch(updateAuthId(""))
    // window.localStorage.removeItem("uid");
    window.location.reload();
  }
    // <input type="text" value={message} onChange={(event) => dispatch(updateMessage(event.target.value))}/>

  // set Google Maps Geocoding API for purposes of quota management. Its optional but recommended.
Geocode.setApiKey(process.env.REACT_APP_GOOGLE_API_KEY);

// set response language. Defaults to english.
Geocode.setLanguage("en");
// set response region. Its optional.
// A Geocoding request with region=es (Spain) will return the Spanish city.
Geocode.setRegion("ke");

// set location_type filter . Its optional.
// google geocoder returns more that one address for given lat/lng.
// In some case we need one address as response for which google itself provides a location_type filter.
// So we can easily parse the result for fetching address components
// ROOFTOP, RANGE_INTERPOLATED, GEOMETRIC_CENTER, APPROXIMATE are the accepted values.
// And according to the below google docs in description, ROOFTOP param returns the most accurate result.
Geocode.setLocationType("ROOFTOP");

// Enable or disable logs. Its optional.
Geocode.enableDebug();

// set response region. Its optional.
// A Geocoding request with region=es (Spain) will return the Spanish city.

  const [lat, setLat] = useState(`${latitude}`)
  const [long, setLong] = useState(`${longitude}`)

  const getLocation = () =>{
    navigator.geolocation.getCurrentPosition(function(position) {

      var lat1 = position.coords.latitude
      var long1 = position.coords.longitude
      setLat(lat1)
      setLong(long1)
     dispatch(updateLatitude(lat1))
     dispatch(updateLongitude(long1))
     getAddress(lat1,long1)
    });
  }

  const clearMyLocation = () => {
    dispatch(updateAddress(''))
    dispatch(updateLatitude(''))
    dispatch(updateLongitude(''))
  }

  console.log(`Lat: ${latitude}`)
  console.log(`Long: ${longitude}`)
  const getAddress = (lat, lng) => {
    // Get address from latitude & longitude.
Geocode.fromLatLng(lat, lng).then(
  (response) => {
    const address = response.results[0].formatted_address;
    dispatch(updateAddress(address))
    toast.success(`Your current address-> ${address}`)
  },
  (error) => {
    console.error(error);
  }
);
  }


  const totalAmount = `${cartCtx.totalAmount.toFixed(2)}`;
  const {items} = cartCtx;
  const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


	const numberOfCartItems = items.reduce((curNumber, item) => {
		return curNumber + item.amount;
	}, 0);

  return (
    <div>
            <Modal show={show4} onHide={handleClose4}>
        <Modal.Body style={{
      maxHeight: 'calc(100vh - 210px)',
      overflowY: 'auto'
     }}>
        <HeaderCategories handleClose={handleClose4}/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose4}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
              <div className="homepage-header">
              {/* <div id="preloader"><div className="preloader"><span /><span /></div></div> */}

        <div className="overlay" />
        <nav className="navbar navbar-expand-lg  osahan-nav shadow-sm" style={{position: 'fixed',width:'100%',backgroundColor:'#fff'}}>
          <div className="container" style={{display:'flex'}}>
            <Link className="navbar-brand" to="/">
              <div style={{display:'flex',alignItems:'center'}}>
                <div><img alt="logo" style={{height:40,width:40,borderRadius:40/2}} src={Logo}/></div> <div style={{marginLeft:2,fontWeight:'bold'}}><i style={{color:'#ff7300'}}>Dot Delivery</i></div>              </div>
              </Link>
              <div className="search120">
        <div className="header_search position-relative">
        <input className="prompt srch10" type="text" onClick={() => handleShow3('xxl-down')} placeholder="Find restaurants near you based on location..." />
          <i className="uil uil-search s-icon" />
        </div>
      </div>
        {/* <div className="header_search position-relative"> */}
          {/* <i className="uil uil-search s-icon" /> */}

            <button className="navbar-toggler"  type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown"  aria-expanded={!isNavCollapsed ? true : false} aria-label="Toggle navigation" onClick={handleNavCollapse}>
              {isNavCollapsed === true?(
                <MenuIcon />
              ):(
                <CancelIcon />
              )}
            </button>

            <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse `} id="navbarNavDropdown">
             
                              <ul className="navbar-nav ml-auto">
                                {/* <li className="nav-item"> */}
                                {/* <span data-bs-toggle="modal" style={{cursor:'pointer',display:'flex',alignItems:'center'}} data-bs-target="#category_model" className="nav-link"><i className="uil" />Category</span> */}

                                {/* </li> */}
                              <li className="nav-item active">
                               <span onClick={() => handleShow3('xxl-down')} className="restaurant_search">
                         <Link className="nav-link">Find Restaurants near you by location</Link>
                                </span>
                                {/* <Link className="nav-link" to="/">Home <span className="sr-only">(current)</span></Link> */}
                              </li>
                              <li  className="nav-item active">
                                <a  onClick={handleShow4} className="nav-link" className="nav-link">Category</a>
                              </li>
                              {/* <li className="nav-item">
                                <a className="nav-link" href="#"><i className="icofont-sale-discount" />Offers</a>
                              </li> */}
                              <li className="nav-item dropdown">
                                <Link className="nav-link dropdown-toggle" to="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  Explore
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right shadow-sm border-0">
                                  <hr />
                                  <Link className="dropdown-item" style={{fontWeight:'bold'}} to="/branches">Restaurants</Link>
                                  <hr />
                                  <Link className="dropdown-item" style={{fontWeight:'bold'}} to="/menu">Menus</Link>
                                  <hr />
                                  <Link className="dropdown-item" style={{fontWeight:'bold'}} to="#">About Us</Link>
                                  <hr />
                                  <Link className="dropdown-item" style={{fontWeight:'bold'}} to="#">Contact Us</Link>
                                  {/* <a className="dropdown-item" to="detail.html">Detail + Cart</a>
                                  <a className="dropdown-item" href="checkout.html">Checkout</a> */}
                                </div>
                              </li>
                              {!loggedUid ?(
                                <>
                              <li onClick={handleShow1} className="nav-item active">
                              <a  className="nav-link">Login/Register</a>
                              </li>
                              <Modal show={show1} onHide={handleClose1}>
        <Modal.Header closeButton>
        <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example"
          style={{backgroundColor:'#f5461b'}}
          
        >
          <Tab label="Sign In" {...a11yProps(0)} />
          <Tab label="Sign Up" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
        </Modal.Header>
        <Modal.Body>
        <Box sx={{ bgcolor: 'background.paper', width: '100%' }}>

      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          <SignIn handleClose={handleClose1}/>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
        <SignUp handleClose={handleClose1}/>
        </TabPanel>

      </SwipeableViews>
    </Box>
        </Modal.Body>
        <Modal.Footer>
          <Button style={{backgroundColor: '#f5461b'}} variant="secondary" onClick={handleClose1}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      </>
                              ):(
                                <li className="nav-item dropdown">
                                <Link className="nav-link dropdown-toggle" to="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  My Account
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right shadow-sm border-0">
                                  <hr />
                                  <Link className="dropdown-item" style={{fontWeight:'bold'}} to={`/my-profile/${auth?.currentUser?.uid}`}>Profile</Link>
                                  <hr />
                                  <Link onClick={logout} className="dropdown-item" style={{fontWeight:'bold'}} to="#">Logout</Link>
                                </div>
                              </li>
                              )}

 
                              <li className="nav-item dropdown dropdown-cart">
                                <Link className="nav-link dropdown-toggle" to="#"  onClick={handleShow}>
                                  <i  className="fas fa-shopping-basket" /> Cart
                                  <span className="badge badge-success">{numberOfCartItems}</span>
                                </Link>

                                <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
            <div style={{width:'100%',alignItems:'center',justifyContent:'space-between',display:'flex'}}>
              <span></span> <span style={{fontWeight:'bold'}}>CART</span> <span><ClearIcon style={{cursor:'pointer'}} onClick={handleClose}/></span>
            </div>
        </Modal.Header>
        <Modal.Body style={{
      maxHeight: 'calc(100vh - 210px)',
      overflowY: 'auto'
     }}>
        <div className="offcanvas-body p-0">
            <div className="side-cart-items">
              <Cart onCloseCart = {() => setShow(false)}/>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>

            <div style={{display:'flex',width:'100%',justifyContent:'space-between',alignItems:'center'}}>
              <span style={{fontWeight:'bold',color:'#cc5500'}}>Total(P): {totalAmount}</span>
              <div >
            {cartCtx.items.length > 0 &&(
                <>
                {auth?.currentUser?.uid ?(
                          <Link to="/check-out" className="cart-checkout-btn hover-btn">Proceed to Checkout</Link>
                ):(
                  <Link onClick={() => setShow1(true)} className="cart-checkout-btn hover-btn">Proceed to Checkout</Link>
                )}
                        
                </>
            )}
        </div>
            </div>
        </Modal.Footer>
      </Modal>
     
                              </li>
                            </ul>
            </div>
          </div>
        </nav>

        <section  className="pt-5 pb-5 homepage-search-block position-relative">
          <div className="banner-overlay" />
          <div style={{marginTop:60}} className="container">
            <div className="row d-flex align-items-center py-lg-4">
              <div className="col-lg-8 mx-auto">
                <div style={{marginTop:20}}  className="homepage-search-title text-center">
                  <h5 className="mb-5 text-shadow text-white-50 font-weight-normal"></h5>
                </div>
                <div className="homepage-search-form">
            {/* <center><button onClick={clearMyLocation}>Clear Address</button></center> */}
                {/* <center>
            {!address ?(
                <GooglePlacesAutocomplete
                style={{width:'100%'}}
   apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
   selectProps={{
   placeholder: `Gaborone, Bostwana`,
   name:"address",
   inputValue:inputFieldHome['address'],
   onInputChange : (e)=>{setInputFieldHome({...inputFieldHome, ['address']: e})},
   onChange:(place) => {handleHomeLatLong(place.label); setErrorAddressHome(false);}
   }}
/>
            ):(
              <GooglePlacesAutocomplete
              style={{width:'100%'}}
 apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
 selectProps={{
 placeholder: `${address}`,
 name:"address",
 inputValue:inputFieldHome['address'],
 onInputChange : (e)=>{setInputFieldHome({...inputFieldHome, ['address']: e})},
 onChange:(place) => {handleHomeLatLong(place.label); setErrorAddressHome(false);}
 }}
/>
            )}

                                 
                </center> */}
                {address ?(
                <center>
                <div style={{display:'flex',width:'100%',flexWrap:'wrap',alignItems:'center'}}>
                <div style={{width:'80%',borderRadius:5}}>
                <GooglePlacesAutocomplete
                style={{width:'100%'}}
   apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
   selectProps={{
   placeholder: `${address}`,
   name:"address",
   inputValue:inputFieldHome['address'],
   onInputChange : (e)=>{setInputFieldHome({...inputFieldHome, ['address']: e})},
   onChange:(place) => {handleHomeLatLong(place.label); setErrorAddressHome(false);}
   }}
/>
                  </div>
                  <div>
                    <center>
                    <button onClick={() => setShow3(true)} style={{backgroundColor:'#e74c3c',height:38,color:'#fff',fontWeight:'bold',padding:5,borderRadius:2,marginLeft:5,alignItems:'center'}}><AddLocationAltIcon style={{fontSize:25}}/></button>
                    </center>
                    </div>
                </div>
              </center>
                ):(
                  <center>
                  <div style={{display:'flex',width:'100%',flexWrap:'wrap'}}>
                  <div style={{width:'80%',borderRadius:5}}>
                <GooglePlacesAutocomplete
                style={{width:'100%'}}
   apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
   selectProps={{
   placeholder: `Gaborone, Bostwana`,
   name:"address",
   inputValue:inputFieldHome['address'],
   onInputChange : (e)=>{setInputFieldHome({...inputFieldHome, ['address']: e})},
   onChange:(place) => {handleHomeLatLong(place.label); setErrorAddressHome(false);}
   }}
/>
                  </div>
                  
                  <div style={{width:'20%'}}>
                  <button onClick={() => setShow3(true)} style={{backgroundColor:'#e74c3c',height:38,color:'#fff',fontWeight:'bold',padding:5,borderRadius:2,marginLeft:5,alignItems:'center'}}><AddLocationAltIcon style={{fontSize:25}}/></button>
                    </div>
                  </div>
                </center>
                )}
        <center style={{marginTop:20}}>

        <h2><span style={{color:'#fff',marginTop:10}}><span> Get food delivery in Botswana.</span>
                    </span></h2>
                  <h5 style={{marginTop:10,color:'#E8E8E8',fontWeight:'800'}}>
                    <p style={{color:'wheat'}}>Get affordable food and fresh groceries delivered to you at an affordable price.</p>
                    {/* <Typewriter
  options={{
    strings: ['Best Restaurants connection.', 'Delicious & affordable meals.','With instant Order.','Fast Delivery on time.'],
    autoStart: true,
    loop: true,
  }}
/> */}
                    </h5>
        </center>
                </div>
                <div style={{marginTop:100}}>
                <h6 className="mt-4 text-shadow text-white font-weight-normal">E.g. Beverages, Pizzas, Cheese, Bakery...</h6>
                <Slider/>
                </div>

              </div>
              
            </div>
          </div>

        </section>
        <Modal show={show3} fullscreen={fullscreen} onHide={() => setShow3(false)}>
        <Modal.Header closeButton>
          <CancelIcon onClick={() => setShow3(false)}/>
        </Modal.Header>
        <Modal.Body>
          <SearchRestaurantLocation />
        </Modal.Body>
      </Modal>
      </div>

    </div>
  )
}

export default Header